import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import CompactLayout from 'src/layouts/compact';
import DashboardLayout from 'src/layouts/dashboard';
// auth
import { AuthGuard } from 'src/auth/guard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/404'));
const Home = lazy(() => import('src/pages/Home'));
const Statistic = lazy(() => import('src/pages/Statistic'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Home />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
  },
  {
    path: '/statistics',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Statistic />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
  },
  // {
  //   path: '/play',
  //   element: (
  //     <AuthGuard>
  //       <Suspense fallback={<LoadingScreen />}>
  //         <Home />
  //       </Suspense>
  //     </AuthGuard>
  //   ),
  // },
  // {
  //   path: '/',
  //   element: (
  //     <AuthGuard>
  //       <Suspense fallback={<LoadingScreen />}>
  //         <Home />
  //       </Suspense>
  //     </AuthGuard>
  //   ),
  // },
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [{ path: '404', element: <Page404 /> }],
  },
];
